<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <!-- <feather-icon icon="SearchIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="detailRecord" /> -->
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />

    <!-- <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    /> -->
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  methods: {
    editRecord() {
      this.$router.push("/userEdit/" + this.params.node.data.userId).catch(() => {});
    },
    detailRecord() {
      this.$router.push("/userEdit/" + this.params.node.data.userId).catch(() => {});
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Silme Onayı`,
        text: `Kişiyi silmek istiyor musunuz ? "${this.params.node.data.userName}"`,
        accept: this.deleteRecord,
        acceptText: "Sil",
        cancelText: "Vazgeç",
      });
    },
    deleteRecord() {
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "bu oz. kullanımda değil",
      });
    },
  },
};
</script>
